export default __webpack_public_path__ + "static/media/oscer-pres-altered-menstrual-bleeding.da8c6ca2.svg";